export default function TSeriesRouteConfig($stateProvider, gettext) {

  'ngInject';

  var tSeriesDashboard = gettext('Dashboard');

  $stateProvider
    .state('tseries', {
      url: '/tseries',
      controller: 'TSeriesDashboardController',
      template: require('./dashboard.html'),
      ncyBreadcrumb: {
        skip: true
      },
      requiredFeatures: ['tseries']
    });
}